export const serverConfig = {
   //BASE_URL: "http://localhost:8080/webnet-hms/api",
   //BASE_URL2: "http://localhost:9000/webnet-hms-pharmacy/api",
   BASE_URL: "https://healthcarelife.in/api",
   BASE_URL2: "https://healthcarelife.in/pharmacy-api",
   SERVER_NAME: "MyServer"
};

export const PRE_LOGIN_UUID = "Pg+KqCtWFcO4qH74BFhnPh0cNupwexdZtPDo/UVYHpA6bnk9BVVWLLHQxjs/ACD/";
export const POST_LOGIN_UUID = "x+6/xjZKH59HbabUNTcMqub0uAiQlCow8U1WqP1Koa/U0+kOCgiO0Kg/9Rhu2M5n";
